// The Ogma logo ("Rising Inscription") from brand/logo/svg: the primary lockup on stone and surfaces, and the
// on-dark lockup when the dark theme is on (styles.css swaps them by theme). Never redrawn or recoloured here.
import logo from "../../../../brand/logo/svg/ogma-logo.svg";
import logoOnDark from "../../../../brand/logo/svg/ogma-logo-on-dark.svg";

export function Logo({ width = 150, className = "" }: { width?: number; className?: string }) {
  const height = Math.round((width * 100) / 605);
  return (
    <span role="img" aria-label="Ogma" className={`logo logo-pair ${className}`.trim()}>
      <img src={logo} alt="" width={width} height={height} className="logo-on-light" />
      <img src={logoOnDark} alt="" width={width} height={height} className="logo-on-dark" />
    </span>
  );
}
